module.exports = __webpack_public_path__ + "img/hm.51c6ce94.svg";